import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca681fb6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca681fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca681fb6')) {
      api.createRecord('ca681fb6', component.options)
    } else {
      api.reload('ca681fb6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ca681fb6&scoped=true&", function () {
      api.rerender('ca681fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/memberTake/index.vue"
export default component.exports